import styled from 'styled-components';
import { TextInputStyles } from '../TextInput/index';

const StyledTextArea = styled.textarea`
  ${TextInputStyles.defaultStyle}
`;

export default StyledTextArea;
